module.exports = __webpack_public_path__ + "img/icon_attribute_happy.722a01f5.png";